import { Observable } from 'rxjs';
import {
  GameConfig,
  GameSummary,
  QuizSubmitRequest,
  QuizSubmitResult,
  QuizTransactionSubmitRequest,
  UserState,
  WheelSpinResult,
} from './game-api.types';

export abstract class GameApi {
  abstract getGames(): Observable<GameSummary[]>;
  abstract getGame(gameId: string): Observable<GameConfig>;

  abstract submitQuiz(req: QuizSubmitRequest): Observable<QuizSubmitResult>;

  abstract submitTransaction(
    req: QuizTransactionSubmitRequest,
  ): Observable<QuizSubmitResult>;

  abstract spinWheel(): Observable<WheelSpinResult>;

  abstract getUserState(): Observable<UserState>;
}
